const Request = require('./BaseRequest')
const YfpGraph = require('../graph/YfpGraph')

module.exports = class YfpRequest extends Request
{
    constructor(apiDomain)
    {
        super(apiDomain)
        this.graph = new YfpGraph(this.apiDomain)
    }
}